import { NullableString } from 'kb-shared';

export const sortNullableStrings = (prev: NullableString, next: NullableString) => {
  if (prev == null) return -1;
  if (next == null) return 1;
  return prev.localeCompare(next);
};
